import mathClamp from '../../utils/Math/clamp'

export default {
  get () {
    return mathClamp(
      this.dirtyScaling,
      this.computedMinScaling,
      this.computedMaxScaling
    )
  },

  set (value) {
    this.dirtyScaling = value
  }
}
